// Module
var code = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 18 18\"><g stroke-width=2><path d=\"M1.686 1.686l14.171 14.171M16.314 1.686L2.143 15.857\"/></g></svg> ";
// Exports
module.exports = code;